import axios from 'axios'

const path = 'api/tasks'
export function GetTasks (filter) {
  if (!filter) {
    filter = ''
  }
  return axios.get(`${window.apiConfig.APIURL + path + filter}`,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    })
}

export function GetTask (id) {
  return axios.get(`${window.apiConfig.APIURL + path}/${id}`,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    })
}

export function GetMaterialsByTaskId (id) {
  return axios.get(`${window.apiConfig.APIURL + path}/${id}/material`,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    })
}

export function GetTimesByTaskId (id) {
  return axios.get(`${window.apiConfig.APIURL + path}/${id}/time`,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    })
}

export async function PostTask (json) {
  return axios.post(`${window.apiConfig.APIURL + path}`, JSON.stringify(json), {
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  })
}
